import React from "react";
import { Link } from "react-router-dom";

const linkSections = [
  {
    title: "Legal",
    links: [
      { to: "/terms-conditions", label: "Terms and Conditions" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/cookie-policy", label: "Cookie Policy" },
      { to: "/aml-policy", label: "AML Policy" },
    ],
  },
  {
    title: "Service",
    links: [
      { to: "/terms-user-creator", label: "Contract between Fan and Creator" },
      { to: "/terms-user", label: "Terms of Service for Fans" },
      { to: "/terms-creator", label: "Terms of Service for Creators" },
      { to: "/refund-policy", label: "Refund Policy" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/mission", label: "Our Mission" },
      { to: "/complaint", label: "Complaint" },
      { to: "/faq", label: "FAQ" },
    ],
  },
];

const Disclaimer = () => {
  return (
    <footer className="disclaimer-footer">
      <div className="disclaimer-footer__top-accent" />
      <div className="disclaimer-footer__content">
        <div className="disclaimer-footer__links">
          {linkSections.map((section) => (
            <div key={section.title} className="disclaimer-footer__section">
              <h6 className="disclaimer-footer__section-title">
                {section.title}
              </h6>
              <ul className="disclaimer-footer__list">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="disclaimer-footer__link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="disclaimer-footer__bottom">
          <p className="disclaimer-footer__copyright">
            &copy; RedCircle {new Date().getFullYear()}, All rights reserved.
          </p>
          <p className="disclaimer-footer__disclaimer">
            This website may contain mature content. All members and persons
            appearing on this site have contractually represented to us that they
            are <strong>18 years of age or older</strong>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Disclaimer;
